export function getProfileName(component, profile) {
    let name = "";
    let values = [];
    if (profile?.displayName) {
        return profile.displayName;
    }
    if (profile?.name) {
        values = profile.name.split("_");
        name = component.$t("profiles.name." + values[0]);
    }
    if (profile.title) {
        if (name) {
            name += " | ";
        }
        name += profile.title;
    } else if (values.length > 1) {
        if (name) {
            name += " | ";
        }
        name += "Personnalisé";
    }
    if (!name) {
        return "XXXX";
    }
    return name;
}
